<div class="code-content scroll-content a_width_100" :class="className" style="max-height: 150px;">{{ getModel }}</div>